import Swiper from "swiper";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export function initSwiper() {


    new Swiper('.hero__carrusel', {
        modules: [ Autoplay, Navigation ],
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
            pauseOnMouseEnter: false
        },
    
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    })
    
    new Swiper('.servicios__carrusel', {
        modules: [ Autoplay, Pagination ],
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true
        },
    
        slidesPerView: 1,
        spaceBetween: 10,
    
        pagination: {
            el: '.servicios__carrusel-nav',
            clickable: true
        },
        // Responsive
        breakpoints: {
            520: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1300: {
                slidesPerView: 4,
                spaceBetween: 20
            }
        }
    })
    
    new Swiper('.whyus__carrusel', {
        modules: [ Autoplay, Pagination ],
        direction: 'horizontal',
        loop: true,
        
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
    
        slidesPerView: 1,
        spaceBetween: 10,
    
        pagination: {
            el: '.whyus__carrusel-nav',
            clickable: true
        },
        // Responsive
        breakpoints: {
            520: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1100: {
                slidesPerView: 3,
                spaceBetween: 20
            }
    /*             992: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: false,
                enabled: false,
                pagination: {
                    el: null
                },
                navigation: {
                    nextEl: null,
                    prevEl: null
                },
            } */
        },
    })
    
    new Swiper('.brands__carrusel', {
        modules: [ Autoplay, Navigation ],
        direction: 'horizontal',
        loop: true,
        
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
    
        slidesPerView: 1,
        spaceBetween: 10,
    
        // Responsive
        breakpoints: {
            520: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            992: {
                slidesPerView: 5,
                spaceBetween: 20
            },
        }
    
    })    

}
